import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import { injectIntl, FormattedMessage } from 'react-intl'


class ThreeDotsButton extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { addNewSection, showConfirmDeleteModal, showLogModal, section, intl } =
      this.props
    return (
      <Dropdown
        id="three-dots-dropdown-experience"
        className="three-dots-dropdown"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <Dropdown.Toggle noCaret className="three-dots-toggle-btn text-btn">
          <img
            src={`${process.env.APP_BASE_URL}dist/images/appbar-three-dots.svg`}
            alt="menu btn"
            width="25px"
            height="25px"
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="three-dots-menu">
          {['Experience', 'Education'].includes(section) ? (
            <>
              <Dropdown.Item
                className="three-dots-menu-item"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  addNewSection()
                }}
                eventKey="1"
              >
                <img
                  className="delete-menu-icon"
                  src={`${process.env.APP_BASE_URL}dist/images/icon-add-new.svg`}
                  alt="Delete icon"
                />
                <FormattedMessage
                  id="aspire.threeDotsButton.addNewSection"
                  defaultMessage="Add new {sectionType, select, education {education} other {position}}"
                  values={{
                    sectionType: section === 'Education' ? 'education' : 'position'
                  }}
                />
              </Dropdown.Item>
              <Dropdown.Item
                className="three-dots-menu-item"
                onSelect={() => showConfirmDeleteModal()}
                onClick={() => showConfirmDeleteModal()}
                eventKey="1"
              >
                <img
                  className="delete-menu-icon"
                  src={`${process.env.APP_BASE_URL}dist/images/icon-delete.svg`}
                  alt="Delete icon"
                />
                <FormattedMessage
                  id="aspire.threeDotsButton.deleteSection"
                  defaultMessage="Delete this {sectionType, select, education {education} other {position}}"
                  values={{
                    sectionType: section === 'Education' ? 'education' : 'position'
                  }}
                />
              </Dropdown.Item>
            </>
          ) : null}
          <Dropdown.Item
            className="three-dots-menu-item"
            onSelect={() => showLogModal(section)}
            eventKey="1"
          >
            <img
              className="delete-menu-icon"
              src={`${process.env.APP_BASE_URL}dist/images/icon-previous-edit.svg`}
              alt="Delete icon"
            />
            <FormattedMessage
              id="aspire.threeDotsButton.previousEdits"
              defaultMessage="Previous Edits"
            />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default injectIntl(ThreeDotsButton)
